import { gql, useLazyQuery } from '@apollo/client';
import { on } from 'events';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { IoSearchOutline } from 'react-icons/io5';
import Loader from 'react-loader-spinner';
import { jsonParseRecursive, yyyymmdd } from '../../function/common';

const JOB_SEARCH = gql`
    query test($queryJobInput: QueryJobInput!) {
        job(input: $queryJobInput) {
            info {
                solType
                solCode
                solUser
                runnerEnv
                resultCallBackUrl
                state
                stateMsg
                promoteAt
                startedAt
                updatedAt
                outPut
            }

            dShopInfo {
                actionName
                accountCode
                siteCode
                id
                pw
                etc
                etc2
                etc3
                etc4
                etc5
                etc6
            }

            prod {
                wdate
                edate
                code
                name3
                name2
                engName
                bonus
                cate1
                cate2
                cate3
                cate4
                cateCode
                tax
                model
                brand
                maker
                madein
                nprice
                wprice1
                wprice2
                sprice
                buy
                deliv
                delivFee
                stock
                misc1
                misc2
                misc3
                misc4
                misc5
                madeDate
                exprDate
                optType
                useAddopt
                modelId
                useSiilData
                useCert
                optTypeSelect
                tmallCatalogId
                inparkCatalogId
                nameShort
                useOptImg
                chinaName
                japanName
                weight
                content
                content2
                content3
                catalogEtc
                keyword1
                keyword2
                keyword3
                keyword4
                keyword5
                addonOpt
                cert
                modelEtc
                siilData
                tmallCatalog_etc
                inparkCatalog_etc
                engKeyword
                chinaKeyword
                japanKeyword
                madeCountry
                hsCode
                engContent
                chinaContent
                japanContent
                imgtag
                siteCode
                siteid
                sitesprice
                siteStock
                siteBuy
                slaveState
                slaveStateOld
                slaveStateDate
                slaveWdate
                slaveRegEdate
                slaveRegCode
                slaveType
                deliv2
                delivFee2
                cateCode2
                img1
                img2
                img3
                img4
                img5
                img6
                img7
                img8
                img9
                img10
                img1Blob
                img2Blob
                img3Blob
                img4Blob
                img5Blob
                img6Blob
                img7Blob
                img8Blob
                img9Blob
                img10Blob
            }
            opt {
                number
                type
                code
                manageCode
                opt1
                opt2
                opt3
                price
                stock
                soldout
                wdate
                optimg
                misc1
                misc2
                misc3
                weight
            }
        }
    }
`;

function JobSearch() {
    // 작업 조회 Graphql 데이터
    const [getJobData, { loading, data, error }] = useLazyQuery(JOB_SEARCH);

    // 상품 선택 변수
    const [prodSelected, setProdSelected] = useState(0);

    // 옵션 선택 변수
    const [optSelected, setOptSelected] = useState(0);

    // react hook form
    const { register, handleSubmit, watch } = useForm();

    // 작업번호
    const jobIdState = watch('searchValue', 0);

    // 검색 타입 (상품 || 주문)
    const jobTypeState = watch('searchType', 'PROD');

    // 검색 솔루션 타입 (EMP || GMP)
    const jobSolTypeState = watch('searchSolType', 'EMP');

    // 작업 조회 (graphql)
    const jobSearchStart = () => {
        // 검색 시 선택값 초기화
        setProdSelected(0);
        setOptSelected(0);

        // graphql 요청
        getJobData({
            variables: {
                queryJobInput: {
                    jobId: jobIdState,
                    jobType: jobTypeState,
                    jobSolType: jobSolTypeState,
                },
            },
        });
    };

    // 상품 재선택 시 옵션 초기화
    useEffect(() => {
        setOptSelected(0);
    }, [prodSelected]);

    return (
        <div id="jobSearch">
            <div className="container">
                <div className="searchWrap">
                    <form onSubmit={handleSubmit(jobSearchStart)}>
                        <select name="searchType" ref={register}>
                            <option value="PROD">상품</option>
                            {/* <option value="ORDER">주문</option> */}
                        </select>
                        <select name="searchSolType" ref={register}>
                            <option value="EMP">EMP</option>
                            {/* <option value="GMP">GMP</option> */}
                        </select>
                        <input
                            type="number"
                            name="searchValue"
                            placeholder="Enter Job Id"
                            ref={register({ valueAsNumber: true })}
                        />
                        <button type="submit">
                            <IoSearchOutline />
                        </button>
                    </form>
                </div>
                {loading ? (
                    <div className="boxWrap">
                        <Loader type="TailSpin" color="#6076ff"></Loader>
                        <p>로딩중...</p>
                    </div>
                ) : error ? (
                    <div className="boxWrap">{error.message}</div>
                ) : (
                    <div className="bottomWrap">
                        <div className="sideBarWrap">
                            {(() => {
                                if (jobTypeState == 'PROD')
                                    return (
                                        <>
                                            <SideBox
                                                title="상품목록"
                                                data={data?.job.prod
                                                    .filter((one: any) => one.code)
                                                    .map((one: any) => one.code)}
                                                selected={prodSelected}
                                                selectedEvent={setProdSelected}
                                            ></SideBox>
                                            <SideBox
                                                title="옵션목록"
                                                data={data?.job.opt
                                                    .filter(
                                                        (one: any) =>
                                                            one.code && one.code == data.job.prod[prodSelected].code,
                                                    )
                                                    .map((one: any) => {
                                                        return `${one.type} - ${one.opt1} / ${one.opt2} / ${one.opt3}`;
                                                    })}
                                                selected={optSelected}
                                                selectedEvent={setOptSelected}
                                            ></SideBox>
                                        </>
                                    );
                                // else if (jobTypeState == 'ORDER') return <ProdData data={data}></ProdData>;
                                // else if (jobTypeState == 'CS') return <ProdData data={data}></ProdData>;
                            })()}
                        </div>

                        <div className="contentWrap">
                            <Box
                                title="작업정보"
                                data={[
                                    { name: '솔루션 타입', value: data?.job.info.solType },
                                    { name: '솔루션 코드', value: data?.job.info.solCode },
                                    { name: '솔루션 유저', value: data?.job.info.solUser },
                                    { name: '작업 상태', value: data?.job.info.state },
                                    { name: '작업 메세지', value: data?.job.info.stateMsg },
                                    {
                                        name: '작업 등록 시간',
                                        value: yyyymmdd(data?.job.info.promoteAt),
                                    },
                                    { name: '작업 시작 시간', value: yyyymmdd(data?.job.info.startedAt) },
                                    { name: '작업 업데이트 시간', value: yyyymmdd(data?.job.info.updatedAt) },
                                ]}
                            ></Box>
                            <Box
                                title="DShopInfo 정보"
                                data={[
                                    { name: '작업 종류', value: data?.job.dShopInfo.actionName },
                                    { name: '업체 코드', value: data?.job.dShopInfo.accountCode },
                                    { name: '쇼핑몰 코드', value: data?.job.dShopInfo.siteCode },
                                    { name: '쇼핑몰 ID', value: data?.job.dShopInfo.id },
                                    { name: '쇼핑몰 PW', value: data?.job.dShopInfo.pw },
                                    { name: '쇼핑몰 부가정보', value: data?.job.dShopInfo.etc },
                                    { name: '쇼핑몰 부가정보2', value: data?.job.dShopInfo.etc2 },
                                    { name: '쇼핑몰 부가정보3', value: data?.job.dShopInfo.etc3 },
                                    { name: '쇼핑몰 부가정보4', value: data?.job.dShopInfo.etc4 },
                                    { name: '쇼핑몰 부가정보5', value: data?.job.dShopInfo.etc5 },
                                    { name: '쇼핑몰 부가정보6', value: data?.job.dShopInfo.etc6 },
                                ]}
                                toggleInitial={true}
                            ></Box>

                            {(() => {
                                if (jobTypeState == 'PROD')
                                    return (
                                        <ProdData
                                            data={data}
                                            prodSelected={prodSelected}
                                            optSelected={optSelected}
                                        ></ProdData>
                                    );
                                else if (jobTypeState == 'ORDER') return <ProdData data={data}></ProdData>;
                                else if (jobTypeState == 'CS') return <ProdData data={data}></ProdData>;
                            })()}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

// 우측 박스 컴포넌트 (string or [{name:"이름", value:"값"}])
const Box = ({ title, data, half = false, left = false, toggleInitial = false }: any) => {
    //
    const [toggle, setToggle] = useState(toggleInitial);

    const clickEvent = () => {
        setToggle(!toggle);
    };

    return (
        <div className={`box ${half && 'half'} ${left && 'left'} ${toggle && 'toggle'}`}>
            <h4 onClick={clickEvent}>{title}</h4>
            <div>
                {data &&
                    (typeof data == 'string'
                        ? data
                        : data.map((one: any, index: number) => (
                              <p key={index}>
                                  <span>{one.name}</span>
                                  <span>{one.value}</span>
                              </p>
                          )))}
            </div>
        </div>
    );
};

// 좌측 박스 컴포넌트
const SideBox = ({ title, data, selected, selectedEvent }: any) => {
    return (
        <div className="box">
            <h4>{title}</h4>
            <div>
                {data &&
                    data.map((one: any, index: number) => (
                        <p
                            className={selected == index ? 'active' : ''}
                            onClick={() => selectedEvent(index)}
                            key={index}
                        >
                            {one}
                        </p>
                    ))}
            </div>
        </div>
    );
};

// 상품타입 컴포넌트
const ProdData = ({ data, prodSelected, optSelected }: any) => {
    console.log(data);
    return (
        <>
            <Box
                title="상품목록"
                data={[
                    { name: '상품 등록일자', value: data?.job.prod[prodSelected].wdate },
                    { name: '상품 만료일', value: data?.job.prod[prodSelected].edate },
                    { name: '마스터상품코드', value: data?.job.prod[prodSelected].code },
                    { name: '상품명', value: data?.job.prod[prodSelected].name3 },
                    { name: '홍보문구', value: data?.job.prod[prodSelected].name2 },
                    { name: '영어상품명', value: data?.job.prod[prodSelected].engName },
                    { name: '사은품 명칭', value: data?.job.prod[prodSelected].bonus },
                    { name: '표준 카테고리코드 대분류', value: data?.job.prod[prodSelected].cate1 },
                    { name: '표준 카테고리코드 중분류', value: data?.job.prod[prodSelected].cate2 },
                    { name: '표준 카테고리코드 소분류', value: data?.job.prod[prodSelected].cate3 },
                    { name: '표준 카테고리코드 세분류', value: data?.job.prod[prodSelected].cate4 },
                    { name: '표준카테고리 전체 코드', value: data?.job.prod[prodSelected].cateCode },
                    { name: '과세여부', value: data?.job.prod[prodSelected].tax },
                    { name: '모델명', value: data?.job.prod[prodSelected].model },
                    { name: '브랜드', value: data?.job.prod[prodSelected].brand },
                    { name: '제조사', value: data?.job.prod[prodSelected].maker },
                    { name: '원산지', value: data?.job.prod[prodSelected].madein },
                    { name: '시중가', value: data?.job.prod[prodSelected].nprice },
                    { name: '원가', value: data?.job.prod[prodSelected].wprice1 },
                    { name: '공급가', value: data?.job.prod[prodSelected].wprice2 },
                    { name: '판매가', value: data?.job.prod[prodSelected].sprice },
                    { name: '구매수', value: data?.job.prod[prodSelected].buy },
                    { name: '배송방법', value: data?.job.prod[prodSelected].deliv },
                    { name: '배송비', value: data?.job.prod[prodSelected].delivFee },
                    { name: '판매재고', value: data?.job.prod[prodSelected].stock },
                    { name: '기타값1', value: data?.job.prod[prodSelected].misc1 },
                    { name: '기타값2', value: data?.job.prod[prodSelected].misc2 },
                    { name: '기타값3', value: data?.job.prod[prodSelected].misc3 },
                    { name: '기타값4', value: data?.job.prod[prodSelected].misc4 },
                    { name: '기타값5', value: data?.job.prod[prodSelected].misc5 },
                    { name: '제조일자', value: data?.job.prod[prodSelected].madeDate },
                    { name: '유효일자', value: data?.job.prod[prodSelected].exprDate },
                    { name: '옵션타입', value: data?.job.prod[prodSelected].optType },
                    { name: '추가구매옵션적용여부', value: data?.job.prod[prodSelected].useAddopt },
                    { name: '5대 오픈마켓 모델 고유코드', value: data?.job.prod[prodSelected].modelId },
                    { name: '품목정보 존재유무', value: data?.job.prod[prodSelected].useSiilData },
                    { name: '인증정보사용여부', value: data?.job.prod[prodSelected].useCert },
                    { name: '선택형옵션의 상세', value: data?.job.prod[prodSelected].optTypeSelect },
                    { name: '11번가 카탈로그', value: data?.job.prod[prodSelected].tmallCatalogId },
                    { name: '인터파크 카탈로그', value: data?.job.prod[prodSelected].inparkCatalogId },
                    { name: '요약상품명', value: data?.job.prod[prodSelected].nameShort },
                    { name: '옵션이미지 사용여부', value: data?.job.prod[prodSelected].useOptImg },
                    { name: '중국어상품명', value: data?.job.prod[prodSelected].chinaName },
                    { name: '일본어상품명', value: data?.job.prod[prodSelected].japanName },
                    { name: '상품무게', value: data?.job.prod[prodSelected].weight },
                    { name: '상세설명', value: data?.job.prod[prodSelected].content },
                    { name: '추가상세설명', value: data?.job.prod[prodSelected].content2 },
                    { name: '광고/홍보', value: data?.job.prod[prodSelected].content3 },
                    { name: '카탈로그 정보(오픈마켓전용', value: data?.job.prod[prodSelected].catalogEtc },
                    { name: '키워드1', value: data?.job.prod[prodSelected].keyword1 },
                    { name: '키워드2', value: data?.job.prod[prodSelected].keyword2 },
                    { name: '키워드3', value: data?.job.prod[prodSelected].keyword3 },
                    { name: '키워드4', value: data?.job.prod[prodSelected].keyword4 },
                    { name: '키워드5', value: data?.job.prod[prodSelected].keyword5 },
                    { name: '추가옵션', value: data?.job.prod[prodSelected].addonOpt },
                    { name: '인증정보', value: data?.job.prod[prodSelected].cert },
                    { name: '샵N 모델명', value: data?.job.prod[prodSelected].modelEtc },
                    { name: '품목정보', value: data?.job.prod[prodSelected].siilData },
                    { name: '11번가 카탈로그', value: data?.job.prod[prodSelected].tmallCatalog_etc },
                    { name: '인터파크 카탈로그', value: data?.job.prod[prodSelected].inparkCatalog_etc },
                    { name: '영어키워드', value: data?.job.prod[prodSelected].engKeyword },
                    { name: '중국어키워드', value: data?.job.prod[prodSelected].chinaKeyword },
                    { name: '일본어키워드', value: data?.job.prod[prodSelected].japanKeyword },
                    { name: '생산지국가', value: data?.job.prod[prodSelected].madeCountry },
                    { name: '전세계배송코드', value: data?.job.prod[prodSelected].hsCode },
                    { name: '영어상세설명', value: data?.job.prod[prodSelected].engContent },
                    { name: '중국어상세설명', value: data?.job.prod[prodSelected].chinaContent },
                    { name: '일본어상세설명', value: data?.job.prod[prodSelected].japanContent },
                    { name: '이미지태그', value: data?.job.prod[prodSelected].imgtag },
                    { name: '쇼핑몰코드', value: data?.job.prod[prodSelected].siteCode },
                    { name: '쇼핑몰 ID', value: data?.job.prod[prodSelected].siteid },
                    { name: '쇼핑몰별 판매가', value: data?.job.prod[prodSelected].sitesprice },
                    { name: '쇼핑몰별 판매수량', value: data?.job.prod[prodSelected].siteStock },
                    { name: '쇼핑몰별 판매수량', value: data?.job.prod[prodSelected].siteBuy },
                    { name: '쇼핑몰별 툴 상품상태', value: data?.job.prod[prodSelected].slaveState },
                    { name: '쇼핑몰별 툴 상품등록일', value: data?.job.prod[prodSelected].slaveWdate },
                    { name: '쇼핑몰별 상품 판매 종료일', value: data?.job.prod[prodSelected].slaveRegEdate },
                    { name: '쇼핑몰별 사이트 상품코드', value: data?.job.prod[prodSelected].slaveRegCode },
                    { name: '쇼핑몰별 판매방식', value: data?.job.prod[prodSelected].slaveType },
                    { name: '쇼핑몰별 배송방법', value: data?.job.prod[prodSelected].deliv2 },
                    { name: '쇼핑몰별 배송비', value: data?.job.prod[prodSelected].delivFee2 },
                    { name: '쇼핑몰별 카테고리 코드', value: data?.job.prod[prodSelected].cateCode2 },
                    { name: '상품 이미지 파일명1 ', value: data?.job.prod[prodSelected].img1 },
                    { name: '상품 이미지 파일명2', value: data?.job.prod[prodSelected].img2 },
                    { name: '상품 이미지 파일명3', value: data?.job.prod[prodSelected].img3 },
                    { name: '상품 이미지 파일명4', value: data?.job.prod[prodSelected].img4 },
                    { name: '상품 이미지 파일명5', value: data?.job.prod[prodSelected].img5 },
                    { name: '상품 이미지 파일명6', value: data?.job.prod[prodSelected].img6 },
                    { name: '상품 이미지 파일명7', value: data?.job.prod[prodSelected].img7 },
                    { name: '상품 이미지 파일명8', value: data?.job.prod[prodSelected].img8 },
                    { name: '상품 이미지 파일명9', value: data?.job.prod[prodSelected].img9 },
                    { name: '상품 이미지 파일명10', value: data?.job.prod[prodSelected].img10 },
                    { name: '상품 이미지1(url', value: data?.job.prod[prodSelected].img1Blob },
                    { name: '상품 이미지2(url', value: data?.job.prod[prodSelected].img2Blob },
                    { name: '상품 이미지3(url', value: data?.job.prod[prodSelected].img3Blob },
                    { name: '상품 이미지4(url', value: data?.job.prod[prodSelected].img4Blob },
                    { name: '상품 이미지5(url', value: data?.job.prod[prodSelected].img5Blob },
                    { name: '상품 이미지6(url', value: data?.job.prod[prodSelected].img6Blob },
                    { name: '상품 이미지7(url', value: data?.job.prod[prodSelected].img7Blob },
                    { name: '상품 이미지8(url', value: data?.job.prod[prodSelected].img8Blob },
                    { name: '상품 이미지9(url', value: data?.job.prod[prodSelected].img9Blob },
                    { name: '상품 이미지10(url', value: data?.job.prod[prodSelected].img10Blob },
                ]}
            ></Box>

            <Box
                title="옵션목록"
                data={(() => {
                    const optData = data?.job.opt.filter((one: any) => one.code == data.job.prod[prodSelected].code)[
                        optSelected
                    ];
                    return (
                        optData && [
                            { name: '옵션별 고유 코드', value: optData.number },
                            { name: '옵션 종류', value: optData.type },
                            { name: '마스터상품코드', value: optData.code },
                            { name: '관리코드', value: optData.manageCode },
                            { name: '옵션타입1의 옵션명', value: optData.opt1 },
                            { name: '옵션타입2의 옵션명', value: optData.opt2 },
                            { name: '옵션타입3의 옵션명', value: optData.opt3 },
                            { name: '옵션 추가 가격', value: optData.price },
                            { name: '옵션 수량', value: optData.stock },
                            { name: '품절여부', value: optData.soldout },
                            { name: '등록일자', value: optData.wdate },
                            { name: '옵션이미지 (url)', value: optData.optimg },
                            { name: '옵션타입1 명칭', value: optData.misc1 },
                            { name: '옵션타입2 명칭', value: optData.misc2 },
                            { name: '옵션타입3 명칭', value: optData.misc3 },
                            { name: '추가무게', value: optData.weight },
                        ]
                    );
                })()}
            ></Box>
            <Box
                title="OUTPUT"
                data={data?.job.info.outPut && JSON.stringify(jsonParseRecursive(data.job.info.outPut))}
            ></Box>
        </>
    );
};

export default JobSearch;
